import { CollapsableText } from 'Components/shared/CollapsableText/CollapsableText';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';

import styles from './RelistDetailsSection.module.scss';

export const RelistDetailsSection: React.FC = () => {
	const {
		relistDetails: { info, name },
	} = useVehicleData();

	return info && name ? (
		<div className={styles.container}>
			<CollapsableText>
				<span className={styles.reason}>{`${name}:`}</span>
				<span className={styles.description}>{info}</span>
			</CollapsableText>
		</div>
	) : null;
};
